import { ROUTE } from "../../../routes";
import { BorderRadiusTokens, ButtonTypeTokens, ColorTokens, IconTokens, SizeTypeTokens, } from "@voltmoney/schema";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
let payloadValue;
export const goToInstructionsPage = async (action, datastore, { setDatastore }) => {
    payloadValue = action?.payload?.value;
    if (action.payload.value === 'yesMutualFund') {
        await setDatastore(action.routeId, 'yesImage', {
            name: IconTokens.YesMutualFundSelected
        });
        await setDatastore(action.routeId, 'noImage', {
            name: IconTokens.NoMutualFundDefault
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, "yesStack", {
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
                borderColor: ColorTokens.Primary_100
            }
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, "noStack", {
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
            }
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, 'yesText', {
            color: ColorTokens.Primary_100
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, 'noText', {
            color: ColorTokens.Grey_Night
        });
    }
    else {
        await setDatastore(action.routeId, 'yesImage', {
            name: IconTokens.YesMutualFundDefault
        });
        await setDatastore(action.routeId, 'noImage', {
            name: IconTokens.NoMutualFundSelected
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, "noStack", {
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
                borderColor: ColorTokens.Primary_100
            },
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, "noText", {
            color: ColorTokens.Primary_100
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, "yesStack", {
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.XS
                },
            }
        });
        await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, "yesText", {
            color: ColorTokens.Grey_Night
        });
    }
    await setDatastore(ROUTE.ASK_MUTUAL_FUND_OLD, "continueButton", {
        type: ButtonTypeTokens.LargeFilled
    });
};
export const goToNextPage = async (action, datastore, { navigate, setDatastore, network, analytics }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userId = userContextResponse.data.user.userId;
    if (payloadValue === 'yesMutualFund') {
        await analytics("mf_yes", { "event": "mf_yes" });
        await network.post(`${api.saveSecurityConsent}${userId}`, {
            consent: "YES"
        }, { headers: await getAppHeader() });
        await navigate(ROUTE.ASK_MUTUAL_FUND);
    }
    else {
        await analytics("mf_no", { "event": "mf_no" });
        await network.post(`${api.saveSecurityConsent}${userId}`, {
            consent: "NO"
        }, { headers: await getAppHeader() });
        await navigate(ROUTE.NO_MUTUAL_FUND_INSTRUCTION);
    }
};
